import React from 'react';
import { Clock } from 'lucide-react';
import { useLanguage } from '../LanguageContext';
import { Users, Heart, Utensils, Music, Moon, Flame } from 'lucide-react';

const iconMap = {
  users: Users,
  heart: Heart,
  utensils: Utensils,
  music: Music,
  moon: Moon,
  flame: Flame
};

export const Program = () => {
  const { t } = useLanguage();
  const programItems = t('program.items');

  return (
    <section id="program" className="program-section">
      <div className="container">
        <div className="section-header">
          <Clock className="section-icon" />
          <h2 className="section-title">{t('program.title')}</h2>
          <div className="decorative-line-small"></div>
        </div>

        <div className="program-timeline">
          {programItems.map((item, index) => {
            const IconComponent = iconMap[item.icon] || Clock;
            return (
              <div 
                key={index} 
                className="program-item"
                data-aos="fade-up"
                data-aos-delay={index * 100}
              >
                <div className="program-time">
                  {item.time}
                </div>
                <div className="program-marker">
                  <div className="program-icon-wrapper">
                    <IconComponent className="program-icon" />
                  </div>
                  {index < programItems.length - 1 && <div className="program-line"></div>}
                </div>
                <div className="program-content">
                  <h3 className="program-title">{item.title}</h3>
                  <p className="program-description">{item.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Program;
